import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCopilot = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      stroke="#007AFF"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m15.228 1.729-.96-.96a.907.907 0 0 0-1.29 0L.769 12.978a.907.907 0 0 0 0 1.29l.96.96a.9.9 0 0 0 1.29 0l12.209-12.21a.9.9 0 0 0 0-1.289M9.5 4.5l2 2M3 3.5v3M13 9.5v3M7 .5v2M4.5 5h-3M14.5 11h-3M7.5 1h-2" />
    </g>
  </svg>
);
const Memo = memo(SvgCopilot);
export default Memo;
